import React, { useRef, useState } from "react";
import { IMAGES } from "../data";

export default function CleaningVideo() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div className="relative rounded-3xl overflow-hidden shadow-xl border border-[#EADFCF] bg-[#2C2523] group">
      {/* Pristine interior image background with video poster */}
      <div className="relative w-full h-[340px] sm:h-[440px] overflow-hidden">
        <img
          src={IMAGES.kitchen}
          alt="Rent og lysfyldt sommerhus køkken"
          className={`w-full h-full object-cover transition-transform duration-1000 ${isPlaying ? 'scale-105' : 'scale-100'} filter brightness-[0.92]`}
        />

        {/* Ambient sunlight beam pulse simulation overlay when playing */}
        {isPlaying && (
          <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent animate-pulse pointer-events-none" />
        )}

        {/* Overlay gradient */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#2C2523]/85 via-black/20 to-black/10 pointer-events-none" />
      </div>

      {/* Video Overlay Content */}
      <div className="absolute inset-0 p-6 sm:p-8 flex flex-col justify-between pointer-events-none">
        <div className="flex items-center justify-between">
          <div className="inline-flex items-center gap-2 bg-[#FAF7F2]/25 backdrop-blur-md text-[#FFFDF9] px-3.5 py-1.5 rounded-full text-xs font-semibold border border-white/20">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
            <span>Skinnende rene resultater</span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div className="text-white space-y-1.5 max-w-lg">
            <h3 className="text-xl sm:text-2xl font-bold font-heading text-white">
              Oplev roen i et nyligt rengjort sommerhus
            </h3>
            <p className="text-xs sm:text-sm text-[#EADFCF] opacity-90 leading-relaxed">
              Vi tager os af alle detaljer – fra skinnende overflader i køkken og badeværelse til nylagte senge og frisk luft.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
